export default __webpack_public_path__ + "static/media/thumb-free.cb6a2fe1.webp";